import { Outlet } from "react-router-dom";

import { CampaignsGrid } from "features/campaigns/components";

export function CampaignsListPage() {
  return (
    <section className="campaigns-list-page main-page">
      <div className="main-page__content">
        <div className="main-page__header">
          <h1>Campaigns List</h1>
        </div>
        <div className="main-page__body">
          <CampaignsGrid />
        </div>
      </div>
      <Outlet />
    </section>
  );
}
